<template>
     <el-dialog title="凭证管理" :visible.sync="pageShow" width="44%">
          <div class="settlelists">
               <el-table :data="dataList" style="width: 100%" ref="tableRef">
                    <el-table-column prop="order_no" label="订单编号"></el-table-column>
                    <el-table-column :label="type_id == 1 ? '应收编号' : '应付编号'">
                         <template slot-scope="{row}">
                              <span v-if="type_id === 1">{{ row.receivable_no }}</span>
                              <span v-if="type_id === 2">{{ row.handle_no }}</span>
                         </template>
                    </el-table-column>
                    <el-table-column label="操作" :width="100">
                         <template slot-scope="{row}">
                              <img src="../../assets/04@2x.png" style="height: 20px;cursor: pointer;"
								@click="get_voucher(row)" />
                         </template>
                    </el-table-column>
               </el-table>
          </div>
          <!-- 上传凭证弹窗 -->
          <v-voucher :dialogVisible="dialogVisible" :detail="detail_info" :type="type_id==1 ?2 :1"  @getModalClose="getModalClose"
			@get_data_amend="get_data_amend"></v-voucher>
          
     </el-dialog>
</template>

<script>
import { getSettlementApi,getVoucherListApi,uploadVoucherApi } from '@/api/index'
import voucher from '../../components/voucher/index.vue'; // 凭证
export default {
     components:{
          'v-voucher': voucher,
     },
     data() {
          return {
               pageShow: false,
               curId: '',
               type_id: '',//1应收 2应付
               dataList: [],
               
               detail_info: {},
			dialogVisible: false,
               subId:''
          }
     },
     methods: {
          open(option) {
               console.log('option', option)
               this.pageShow = true;
               this.curId = option.id;
               this.type_id = option.type_id;
               this.getSettlement();
          },
          close() {
               this.pageShow = false;
          },
          /* 获取结算情况列表 */
          getSettlement() {
               getSettlementApi({ id: this.curId }).then(res => {
                    console.log('获取结算情况列表', res)
                    this.dataList = res.data;
               })
          },
          // 凭证
		get_voucher(e) {
			console.log('wwww', e)
               // this.dialogVisible = true;
               // 	this.detail_info = {
			// 		order_id: e.order_id,
			// 		order_no: e.order_no,
			// 		// imgs: res.data,
			// 		type_id: '',
			// 		type_name: ''
			// 	}
               this.subId=e.id;
			getVoucherListApi({
				id:this.curId,
                    ids:e.id
			}).then(res => {
				console.log('res.data.,', res.data)
				this.dialogVisible = true;
				this.detail_info = {
					order_id: e.order_id,
					order_no: e.order_no,
					imgs: res.data,
					type_id: '',
					type_name: ''
				}
				console.log('this.detail_info', this.detail_info)
			})
		},
		getModalClose(e) {
			this.dialogVisible = e;
		},
		get_data_amend(e) {
			console.log('get_data_amend', e)
			// let img_array = [];
			this.dialogVisible = false;

			// img_array= e.imgs.forEach((n, k) => {
			// 	if (!n.id) {
			// 		img_array.push(n.images)
			// 	}
			// })
			let img_array = e.imgs.map(item => {
				return {
					type_id: item.belongTypeId,
					images: item.images
				}
			})

			if (img_array.length === 0) return
			console.log('接收', img_array)

			uploadVoucherApi({
				id:this.curId,
                    ids:this.subId,
				images: img_array
				// image:img_array.join(','),
				// type_id: e.type_id,
			}).then(res => {
				console.log('接收后接口返回', res)
				this.$message.success('上传凭证成功');
                    this.subId='';
				this.getSettlement();
			})
		},
     },
}
</script>

<style lang="less" scoped>
.demo-ruleForm {
     margin-top: 30px;
}
</style>